import * as yup from 'yup';

export const commonPortValidation: { [x: string]: any; } = {
    portCode: yup.string().required("Missing."),
    portName: yup.string().required("Missing."),
    effectiveDate: yup.date().required("Missing."),
    countryCode: yup.string().required("Missing."),
    geogInd: yup.string().required("Missing."),
    activeInd: yup.string().required("Missing."),
};

export const createPortValidation: { [x: string]: any; } = {
    ...commonPortValidation,
};

export const createPortValidationSchema = yup.object().shape(createPortValidation);

